import { useMemo } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import ICON_HOT_ICON from "@/assets/images/hot-icon.svg";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";

const THU_VIET = ["Chủ nhật", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"];

const buildDateOptions = (today, direction = 'forward') => {
  const options = [
    { value: "live", label: "Trực Tiếp", icon: ICON_HOT_ICON },
    { value: today.format("YYYY-MM-DD"), label: "Hôm nay" },
  ];
  
  if (direction === 'backward') {
    options.shift();
  }

  for (let i = 1; i <= 7; i++) {
    const d = direction === 'backward' 
      ? today.clone().subtract(i, "day")
      : today.clone().add(i, "day");
    const thu = THU_VIET[d.day()];
    options.push({
      value: d.format("YYYY-MM-DD"),
      label: `${thu} (${d.format("DD/MM")})`,
    });
  }
  return options;
};

const KbvDateRange = ({ value, onChange, className = "", direction = 'forward', }) => {
  const today = dayjs().tz(TZ);
  const options = useMemo(() => buildDateOptions(today, direction), [today, direction]);

  return (
    <div className={`flex items-center overflow-x-auto max-md:scrollbar-hide pb-4 gap-2.5 ${className}`}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={`hover:brightness-110 inline-flex items-center gap-1 px-2 py-1.5 rounded text-sm items-center justify-center font-medium transition-colors cursor-pointer rounded-full whitespace-nowrap shrink-0
             ${ "live" == opt.value ? "min-w-[100px]" : ""}
             
             ${ today.format("YYYY-MM-DD") == opt.value ? "min-w-[80px]" : ""}

             ${value === opt.value
              ? "bg-[var(--theme-primary)] text-[var(--theme-on-primary)] font-semibold"
              : "bg-[var(--theme-bg)] text-[var(--theme-text)] font-medium"
            }`}
        >
          {opt.icon && (
            <img src={opt.icon} alt="" className="w-4 h-4 object-contain" />
          )}
          
          <span className="text-sm font-medium">{opt.label}</span>
          
        </button>
      ))}
    </div>
  );
};

export default KbvDateRange;